import { GetterTree, ActionTree, MutationTree } from "vuex";

export class DashboardKPITablesState {
  needsRefresh = false;
  departuresNeedRefresh = false;
  showOwnersReservations = false;
}

const initialState = new DashboardKPITablesState();

const state = { ...initialState };

const getters: GetterTree<DashboardKPITablesState, any> = {
  needsRefresh: (s) => s.needsRefresh,
  departuresNeedRefresh: (s) => s.departuresNeedRefresh,
  showOwnersReservations: (s) => s.showOwnersReservations
};
const actions: ActionTree<DashboardKPITablesState, any> = {
  setNeedsRefresh({ commit }, payload: boolean) {
    commit("setNeedsRefresh", payload);
  },
  setDeparturesNeedRefresh({ commit }, payload: boolean) {
    commit("setDeparturesNeedRefresh", payload);
  },
  setShowOwnersReservations({ commit }, payload: { value: boolean; utid: number }) {
    commit("setShowOwnersReservations", payload);
  }
};
const mutations: MutationTree<DashboardKPITablesState> = {
  setNeedsRefresh: (state, value: boolean) => {
    state.needsRefresh = value;
  },
  setDeparturesNeedRefresh: (state, value: boolean) => {
    state.departuresNeedRefresh = value;
  },
  setShowOwnersReservations: (state, payload: { value: boolean; utid: number }) => {
    state.showOwnersReservations = payload.value;
    localStorage.setItem("pms.utid_" + payload.utid + "_dashboard.showOwnerRes", JSON.stringify(payload.value));
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};

export const dashboardAccUnitStatuses = [
  {
    id: 1,
    color: "success",
    text: "t.AccomodationUnitStatus.Ready",
  },
  {
    id: 2,
    color: "warning",
    text: "t.AccomodationUnitStatus.NeedsCleaning",
  },
  {
    id: 3,
    color: "warning",
    text: "t.AccomodationUnitStatus.NeedsRepair",
  },
  {
    id: 4,
    color: "accent",
    text: "t.AccomodationUnitStatus.CleaningInProgress",
  },
  {
    id: 5,
    color: "accent",
    text: "t.AccomodationUnitStatus.RepairInProgress",
  },
];
